export function getFromLocalStorage<T>(key: string): T | null {
    const item = localStorage.getItem(key);
    if (!item) return null;
  
    try {
      return JSON.parse(item) as T;
    } catch (error) {
      console.error(`Error parsing localStorage item "${key}":`, error);
      return null;
    }
  }
  
export function setInLocalStorage<T>(key: string, value: T): void {
    try {
      const valueString = JSON.stringify(value);
      localStorage.setItem(key, valueString);
    } catch (error) {
      console.error(`Error stringifying value for localStorage key "${key}":`, error);
    } 
  }

export function removeFromLocalStorage(key: string): void {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      console.error(`Error removing localStorage item "${key}":`, error);
    }
  }